export default {
  orderStatus: {
    0: 'Você enviou o pedido, por favor, aguarde o comprador aceitar o pedido',
    23: 'Comprador aceitou o pedido, está se comunicando com o comerciante',
    5: 'Seu produto foi pedido, número da transação:',
    22: 'Seu produto foi pedido, número da transação:',
    10: 'Seus produtos chegaram ao armazém designado acbuy',
    16: 'Você enviou solicitação de devolução, por favor, aguarde o comprador processar',
    17: 'Você enviou solicitação de troca, por favor, aguarde o comprador processar',
    buyerReturn:
      'O comprador, devido a necessidades do cliente, riscos do produto, etc., já ajudou a enviar solicitação de devolução, por favor, aguarde com paciência o resultado do processamento',
    buyerReplace:
      'O comprador, devido a necessidades do cliente, riscos do produto, etc., já ajudou a enviar solicitação de troca, por favor, aguarde com paciência o resultado do processamento',
    20: 'Este pedido foi concluído com devolução,',
    beenReturned: ' Ver reembolso >',
    30: 'Seus produtos foram enviados, ver pacote:',
    43: 'Sua solicitação de devolução foi cancelada',
    44: 'Sua solicitação de troca foi cancelada',
    49: 'Usuário não renovou serviço de armazenamento, padrão abandonar produto',
  },
  expressNo: 'Número da guia de logística:',
}
